<template>
  <div id="mobileHeader" class="mobileHeader">
    <div class="top-wrapper">
      <div class="top">
        <img id="open-menu" class="menu-icon" src="@/assets/img/icon/menu.png" @click="openHamburgerMenu" alt="" />
        <img class="logo" :src="getLogoImgUrl()" alt="" />
        <div class="mobile-lang-block" v-if="!['zh_hk'].includes(language)">
          <langSelectedBlock ref="langSelectedBlock" @getOpenLangStatus="getOpenLangStatus" :is-open-lang.sync="isOpenLang"></langSelectedBlock>
        </div>
        <div class="lang-group" v-if="isOpenLang" v-on-click-outside="closeLangBlock">
          <langSelectList @getLangSelected="getLangSelected"></langSelectList>
        </div>
      </div>
    </div>
    <div class="dropdown-menu-bg" :class="{ 'isOpenHamburgerMenu': isOpenMenu }" v-on-click-outside="closeHamburgerMenu">
      <ul class="parent">
        <li class="close">
          <img class="close-menu" src="@/assets/img/icon/close.png" @click="closeHamburgerMenu" alt="" />
        </li>
        <li>
          <div class="mobile-login-block">
            <loginBlock></loginBlock>
          </div>
        </li>
        <li>
          <recordBlockComponent></recordBlockComponent>
        </li>
        <li style="position: relative;" @click="toggleSettingList">
          <img class="arrow-icon" src="@/assets/img/icon/expand.png" :class="{ 'transform180': isOpenSetting }" alt="" />
          <settingSelectedBlock ref="settingSelectedBlock" @getOpenSettingStatus="getOpenSettingStatus" :is-open-setting.sync="isOpenSetting"></settingSelectedBlock>
        </li>
      </ul>
      <settingSelectList v-if="isOpenSetting"></settingSelectList>
      <div class="version-block" :class="{ 'resetPosition': isOpenSetting }">Version: {{ version }}</div>
    </div>
    <div class="cover-bg" :class="{ 'showIsOpenMenu': isOpenMenu, 'showIsOpenLang': isOpenLang }"></div>
  </div>
</template>

<script>
import record from './btn/record'
import langSelectedBlock from './btn/lang/langSelectedBlock'
import langSelectList from './btn/lang/langSelectList'
import settingSelectList from './btn/setting/settingSelectList'
import settingSelectedBlock from './btn/setting/settingSelectedBlock'
import loginBlock from './loginBlock'
import Base from '@/mixins/base'
import { mixin as onClickOutside } from 'vue-on-click-outside'
import { mapGetters } from 'vuex'

export default {
  name: 'mobileHeader',
  mixins: [
    Base,
    onClickOutside
  ],
  data() {
    return {
      isOpenMenu: false,
      version: process.env.VUE_APP_VERSION
    }
  },
  computed: {
    ...mapGetters({
      language: 'app/getLanguage'
    })
  },
  components: {
    'recordBlockComponent': record,
    langSelectedBlock,
    langSelectList,
    settingSelectList,
    settingSelectedBlock,
    loginBlock
  },
  watch: {
    isOpenLang: function(val) {
      this.freezeBody(val)
    },
    isOpenMenu: function(val) {
      this.freezeBody(val)
    }
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    /**
     * 觸發開啟設定選單
     */
    toggleSettingList() {
      this.$refs.settingSelectedBlock.openList()
    },
    /**
     * 開啟漢堡選單
     */
    openHamburgerMenu() {
      this.isOpenMenu = true
      this.isOpenLang = false
    },
    /**
     * 關閉漢堡選單
     */
    closeHamburgerMenu(event) {
      // 當前點擊的event.target.id 不是漢堡選單 才能執行
      if (event.target.id === 'open-menu') return
      this.isOpenMenu = false
    },
    /**
     * body鎖定
     */
    freezeBody(val) {
      // 禁止漢堡選單或語系清單開啟時 背景的捲軸滾動
      // 且畫面會跳回頂部
      const bodyEl = document.querySelector('body')
      if (val === true) {
        bodyEl.classList.add('hidden-scroll')
        // 選單開啟 設定body背景
        const scrollY = document.documentElement.style.getPropertyValue('--scroll-y')
        bodyEl.style.position = 'fixed'
        bodyEl.style.top = `-${scrollY}`
      } else {
        bodyEl.classList.remove('hidden-scroll')
        // 選單關閉 設定body背景
        const scrollY = bodyEl.style.top
        bodyEl.style.position = ''
        bodyEl.style.top = ''
        window.scrollTo(0, parseInt(scrollY || '0') * -1)
      }
    }
  }
}
</script>

<style scoped></style>
